<div class="d-flex flex-column">
  <input
    type="text"
    class="form-control has-validation"
    [formControl]="formControl"
    [class.disabled]="formControl.disabled"
    [required]="formControl.hasValidator(requiredValidator)"
    [class.is-invalid]="(formControl.touched && !formControl.valid)|| !!formControl.getError('serverError')"
    [class.is-valid]="formControl.touched && formControl.valid"
  >

  @if (formControl.touched && formControl.invalid) {
    @if (!!formControl.getError('serverError')) {
      <div class="invalid-feedback p-0">{{ formControl.getError('serverError') }}</div>
    }

    @for (err of formControl.errors | keyvalue; track err) {
      @if (errorMessages && errorMessages[err.key]) {
        <div class="invalid-feedback p-0">
          {{ errorMessages[err.key] }}
        </div>
      } @else if ((!errorMessages || !errorMessages[err.key]) && err.key !== 'serverError') {
        <div class="invalid-feedback p-0">
          {{ 'forms.errors.' + err.key | translate }}
        </div>
      }
    }
  }
</div>
